import {
	Culture, DateFormatDescription, DateOnly, DateTime,
	DateTimeFormatDescription,
	ensureErrorType,
	NumberFormatDescription, TimeOnly
} from "@2d-front-monorepo/core";
import {API_ENDPOINT} from "./api-endpoint";
import {GlobalContext} from "./contexts/GlobalContext";

type ErrorEntry = {
	name: string;
	message: string;
	stack: string;
	cause: string | undefined;
};

function errorToErrorEntry(error: Error): ErrorEntry {
	return {
		name: error.name,
		message: error.message,
		stack: error.stack || error.toString(),
		cause: error.cause == null ? undefined : JSON.stringify(errorToErrorEntry(ensureErrorType(error.cause)))
	}
}

export function formatDateTime(date: DateTime): string {
	return Culture.getCurrent().formatDateTime(date, DateTimeFormatDescription.Medium);
}

export function formatDate(date: DateOnly): string {
	return Culture.getCurrent().formatDate(date, DateFormatDescription.Medium);
}

export function formatTime(time: TimeOnly): string {
	return Culture.getCurrent().formatTime(time, "short-time");
}

export function formatDateTimeShort(date: DateTime): string {
	return Culture.getCurrent().formatDateTime(date, DateTimeFormatDescription.Short);
}

export function formatCurrency(value?: number | null | undefined): string {
	if (value == null) {
		return "";
	}

	return Culture.getCurrent().formatNumber(value / 100, NumberFormatDescription.Currency);
}

export function reportError(error: unknown): void {
	const installationId = GlobalContext.tryGetData()?.installation?.id;
	fetch(`${API_ENDPOINT.errorLogging}?installationId=${installationId}`, {
		body: JSON.stringify(errorToErrorEntry(ensureErrorType(error))),
		headers: {"Content-Type": "application/json"},
		method: "POST",
		credentials: "include"
	}).catch((_) => {
	});
}
